import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateHolder } from '../../shared';
import { SessionService, SidebarService } from '../../services';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { DebugLoggerService } from '../../services/debug-logger.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
    standalone: true,
    imports: [NgTemplateOutlet, TooltipModule, TranslateModule, AsyncPipe]
})
export class SidebarComponent {
  sidebarSrv = inject(SidebarService);
  private _ssnService = inject(SessionService);
  private _route = inject(Router);
  appStateHolder = inject(AppStateHolder);
  private _debugLogger = inject(DebugLoggerService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }

  public expandSidebar(): void {
    const expanded = !this.sidebarSrv.getStateExpanded;
    this._debugLogger.logAction('Sidebar', 'toggleExpand', { expanded });
    this.sidebarSrv.setExpand(expanded);
  }

  public goTo(link: string): void {
    this._debugLogger.logNavigation(link);
    this._route.navigate([link]);
  }

  public goBack(): void {
    this._debugLogger.logAction('Sidebar', 'goBack');
    this.sidebarSrv.goBack();
  }
}
